import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { LinksCard } from "./card";
import { setDocumentTitle } from "@/lib/documentTitle";

import { LinksTable } from "./table";

export default function Links() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portfolio Links");
  }, []);

  return (
    <Routes>
      <Route index element={<LinksTable />} />
      <Route path=":id" element={<LinksCard />} />
    </Routes>
  );
}
